// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as TicketVm from "../../vm-mapper/TicketVm.bs.js";
import * as OrderStage from "../../../app/tickets/entities/OrderStage.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as CardSeparator from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/CardSeparator.bs.js";
import * as RecordsWrapper from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/RecordsWrapper.bs.js";
import * as CardTitleWithImage from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/CardTitleWithImage.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as TicketDashboardAssetsManager from "../../assets/TicketDashboardAssetsManager.bs.js";

var ticket_icon = TicketDashboardAssetsManager.getImage("ticket.svg");

function getViewLabel(ticket) {
  return {
          hd: {
            label: "Case No.",
            value: {
              TAG: /* Text */0,
              _0: ticket.case_number
            }
          },
          tl: {
            hd: {
              label: "Status",
              value: {
                TAG: /* Text */0,
                _0: TicketStatus.toString(ticket.status)
              }
            },
            tl: {
              hd: {
                label: "Type",
                value: {
                  TAG: /* Text */0,
                  _0: ticket.ticket_type
                }
              },
              tl: /* [] */0
            }
          }
        };
}

function TicketBasicDetailsCmp$BaseDetails(Props) {
  var ticket = Props.ticket;
  return React.createElement(CardComponent$Catalyst.make, {
              className: "info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(ticket))
                  })
            });
}

var BaseDetails = {
  getViewLabel: getViewLabel,
  make: TicketBasicDetailsCmp$BaseDetails
};

function getViewLabel$1(ticket) {
  var value = ticket.author;
  return {
          hd: {
            label: "Raised at",
            value: {
              TAG: /* Text */0,
              _0: Timestamp$Catalyst.toString(ticket.raised_at, "DD/MM/YYYY | hh:mm A")
            }
          },
          tl: {
            hd: {
              label: "Raised by",
              value: {
                TAG: /* Text */0,
                _0: ticket.raised_by
              }
            },
            tl: {
              hd: {
                label: "Author",
                value: {
                  TAG: /* Text */0,
                  _0: value !== undefined ? value : "N/A"
                }
              },
              tl: {
                hd: {
                  label: "Escalate To",
                  value: {
                    TAG: /* Text */0,
                    _0: Belt_Option.getWithDefault(ticket.escalate_to, "--")
                  }
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function TicketBasicDetailsCmp$CreationDetails(Props) {
  var ticket = Props.ticket;
  return React.createElement(CardComponent$Catalyst.make, {
              className: "info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel$1(ticket))
                  })
            });
}

var CreationDetails = {
  getViewLabel: getViewLabel$1,
  make: TicketBasicDetailsCmp$CreationDetails
};

function getViewLabel$2(ticket) {
  return {
          hd: {
            label: "Order Stage",
            value: {
              TAG: /* Text */0,
              _0: Belt_Option.mapWithDefault(ticket.order_stage, "--", OrderStage.toString)
            }
          },
          tl: {
            hd: {
              label: "Issues",
              value: {
                TAG: /* Text */0,
                _0: $$String.concat("/", ticket.issues)
              }
            },
            tl: {
              hd: {
                label: "Action Taken",
                value: {
                  TAG: /* Text */0,
                  _0: $$String.concat("/", ticket.actions)
                }
              },
              tl: /* [] */0
            }
          }
        };
}

function TicketBasicDetailsCmp$TicketDescription(Props) {
  var ticket = Props.ticket;
  return React.createElement(CardComponent$Catalyst.make, {
              className: "info-card ticket-issues-actions",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel$2(ticket))
                  })
            });
}

var TicketDescription = {
  getViewLabel: getViewLabel$2,
  make: TicketBasicDetailsCmp$TicketDescription
};

function TicketBasicDetailsCmp(Props) {
  var ticket = Props.ticket;
  var match = TicketVm.getVm(ticket);
  var ticket$1 = match.ticket;
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Ticket Details",
                                icon_src: ticket_icon
                              });
                  })
              },
              action: undefined,
              children: null
            }, React.createElement(TicketBasicDetailsCmp$BaseDetails, {
                  ticket: ticket$1
                }), React.createElement(CardSeparator.make, {}), React.createElement(TicketBasicDetailsCmp$CreationDetails, {
                  ticket: ticket$1
                }), React.createElement(CardSeparator.make, {}), React.createElement(TicketBasicDetailsCmp$TicketDescription, {
                  ticket: ticket$1
                }));
}

var make = TicketBasicDetailsCmp;

export {
  ticket_icon ,
  BaseDetails ,
  CreationDetails ,
  TicketDescription ,
  make ,
  
}
/* ticket_icon Not a pure module */
